// Batch 34 · fork M — S20: a support reference built from the document's DOC ref and file name (no reference read). EN + AR.
export const I18N_B34M = {
  en: {
    b34m: {
      refFromName: "from file name",
      refFromNameTitle: "No reference was read from the document — the DOC ref and file name are shown (automatic). Type a reference to replace it.",
    },
  },
  ar: {
    b34m: {
      refFromName: "من اسم الملف",
      refFromNameTitle: "لم يُقرأ مرجع من المستند — يُعرض رقم المستند واسم الملف (تلقائياً). اكتب مرجعاً لاستبداله.",
    },
  },
};

export default I18N_B34M;
